import styled from 'styled-components'

export const MedicalCoverageCardWrapper = styled.div`
  border: 1px solid var(--card-border);
  border-radius: 6px;
  width: 23rem;
  padding: 1rem;
`
